<template>
  <div v-if="data.Name" class="cert-info">
    <div class="cert-head">
      <el-row>
        <el-col :span="5">
          <img :src="data.Pic" alt="" srcset="">
        </el-col>
        <el-col :span="17">
          <div style="margin-top: 10px;">
            <div>{{ data.Name }}</div>
            <div>{{ data.CourseName }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="cert-panel">
      <div class="cert-title">证书信息</div>
      <div class="cert-content">
        <!-- <el-row v-if="data.CertStateId == 2" class="yc-item">
          <el-col class="cert-label" :span="7">
            证书状态：
          </el-col>
          <el-col :span="17">
            {{data.CertStateName}}
          </el-col>
        </el-row> -->
        <el-row>
          <el-col class="cert-label" :span="7">
            证书编号：
          </el-col>
          <el-col :span="17">
            {{ code }}
          </el-col>
        </el-row>
        <el-row>
          <el-col class="cert-label" :span="7">
            身份证号：
          </el-col>
          <el-col :span="17">
            {{ data.IdNumber }}
          </el-col>
        </el-row>
        <el-row>
          <el-col class="cert-label" :span="7">
            性　　别：
          </el-col>
          <el-col :span="17">
            {{ data.SexDescription }}
          </el-col>
        </el-row>
        <el-row>
          <el-col class="cert-label" :span="7">
            专　　业：
          </el-col>
          <el-col :span="17">
            {{ data.JobName }}
          </el-col>
        </el-row>
        <el-row>
          <el-col class="cert-label" :span="7">
            有效期始：
          </el-col>
          <el-col :span="17">
            {{ data.BeginDate | dateformat}}
          </el-col>
        </el-row>
        <el-row>
          <el-col class="cert-label" :span="7">
            有效期至：
          </el-col>
          <el-col :span="17">
            {{ data.ExpirDate | dateformat}}
          </el-col>
        </el-row>
        <el-row>
          <el-col class="cert-label" :span="7">
            培训单位：
          </el-col>
          <el-col :span="17">
            {{ data.Authority }}
          </el-col>
        </el-row>
        <el-row>
          <el-col class="cert-label" :span="7">
            发证日期：
          </el-col>
          <el-col :span="17">
            {{ data.CreateTime | dateformat}}
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
  <div v-else>
    证书不存在
  </div>
</template>
<script>
import { mapGetters } from '@/views/base/base.js'
export default {
  name: 'examcert',
  data: function () {
    return {
      code: null,
      idNumber: null
    }
  },
  computed: {
    ...mapGetters({
      data: 'getCert'
    })
  },
  filters: {
    dateformat(dataStr, pattern = 'YYYY年MM月DD日') {
      if (dataStr === null) {
        return '';
      }
      return moment(dataStr).format(pattern)
    }
  },
  mounted: function () {
    this.code = this.$route.query.code;
    this.idNumber = this.$route.query.idNumber;
    this.$store.dispatch('getCert', { code: this.code, idNumber: this.idNumber });
  },

  methods: {

  }
};
</script>
<style lang="scss" scoped>
.cert-info {
  color: #303133;
  line-height: 32px;
  font-size: 18px;
}
.cert-head {
  padding: 20px;
  border-top: 10px solid #eee;
  border-bottom: 10px solid #eee;
  img {
    width: 60px;
  }
}
.cert-panel {
  .cert-title {
    font-weight: bold;
    font-size: 20px;
    color: #409eff;
    padding: 0 20px;
    line-height: 60px;
    border-bottom: 1px solid #eee;
  }
  .cert-content {
    padding: 20px;
    line-height: 40px;
    .cert-label {
      color: #909399;
    }
    .yc-item {
      .el-col {
        color: #ff6715 !important;
        font-weight: bold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/examcert.vue